import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class QuickPostImageShape extends BaseOption {
  static userInterfaceComponent = {
    label: "Attached image shape",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Any",
          value: 0,
        },
        {
          label: "Square",
          value: 1,
        },
        {
          label: "Portrait",
          value: 0.8,
        },
        {
          label: "Landscape",
          value: 1.7778,
        },
      ],
    },
  };

  static defaultValue = 0;
}
